export function FormValidationMessage({ errorMessage }: { errorMessage: string }) {
    return (
        <div className={"rounded-lg border-card-foreground/20 border bg-card p-3 flex flex-col gap-2"}>
            <p className={"text-sm text-destructive"}>{errorMessage}</p>
        </div>
    );
}
